import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivacyPolicy from './PrivacyPolicy';
import ReceiptOCR from './ReceiptOCR'; // 追加！

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ReceiptOCR />} /> {/* ← ここがトップ */}
        <Route path="/privacy_policy" element={<PrivacyPolicy />} />
        {/* 他のルートもここに追加できます */}
      </Routes>
    </Router>
  );
};

export default App;
